import { useState } from "react";
import { useHistory, useLocation } from "react-router";

import URLUtils from "./URLUtils";

export default function useAlertState(name: string) {
    const [isOpen, setIsOpen] = useState<boolean>(false);

    const location = useLocation();
    const navigation = useHistory();
    const toggleAlert = (open: boolean) => {
        if(open) {
            URLUtils.appendSearchParam(navigation, location, `${name}Alert`, 'true');
            setIsOpen(true);
        }
        else {
            if(location.location?.search?.includes(`${name}Alert=true`)) {
                navigation.go(-1); // navigate to the previous url (w/o the modal search param)
            }
            setIsOpen(false);
        }
    }
    const closeOnSearchParamChange = () => {
        if(!location.location?.search?.includes(`${name}Alert=true`)) {
            setIsOpen(false); // close alert when the search param changes
        }
    }

    return {
        isOpen,
        setIsOpen: toggleAlert,
        closeOnBackButton: closeOnSearchParamChange,
        useEffectParam: location
    }
}
